export default {
  FETCH_ALL_MENU_ITEMS_SUCCESS: 'FETCH_ALL_MENU_ITEMS_SUCCESS',
  FETCH_ALL_MENU_ITEMS_LOADING: 'FETCH_ALL_MENU_ITEMS_LOADING',
  FETCH_ALL_MENU_ITEMS_REJECT: 'FETCH_ALL_MENU_ITEMS_REJECT',
  FETCH_ALL_MENU_ITEMS_FAILED: 'FETCH_ALL_MENU_ITEMS_FAILED',


  CHANGE_MENU_ITEM_STATUS_SUCCESS: 'CHANGE_MENU_ITEM_STATUS_SUCCESS',
  CHANGE_MENU_ITEM_STATUS_LOADING: 'CHANGE_MENU_ITEM_STATUS_LOADING',
  CHANGE_MENU_ITEM_STATUS_REJECT: 'CHANGE_MENU_ITEM_STATUS_REJECT',
  CHANGE_MENU_ITEM_STATUS_FAILED: 'CHANGE_MENU_ITEM_STATUS_FAILED',

  FETCH_ALL_DELETED_MENU_ITEMS_SUCCESS: 'FETCH_ALL_DELETED_MENU_ITEMS_SUCCESS',
  FETCH_ALL_DELETED_MENU_ITEMS_LOADING: 'FETCH_ALL_DELETED_MENU_ITEMS_LOADING',
  FETCH_ALL_DELETED_MENU_ITEMS_REJECT: 'FETCH_ALL_DELETED_MENU_ITEMS_REJECT',
  FETCH_ALL_DELETED_MENU_ITEMS_FAILED: 'FETCH_ALL_DELETED_MENU_ITEMS_FAILED',

  DELETE_MENU_ITEM_SUCCESS: 'DELETE_MENU_ITEM_SUCCESS',
  DELETE_MENU_ITEM_LOADING: 'DELETE_MENU_ITEM_LOADING',
  DELETE_MENU_ITEM_REJECT: 'DELETE_MENU_ITEM_REJECT',
  DELETE_MENU_ITEM_FAILED: 'DELETE_MENU_ITEM_FAILED',

  FETCH_MENU_ITEM_BY_ID_SUCCESS: 'FETCH_MENU_ITEM_BY_ID_SUCCESS',
  FETCH_MENU_ITEM_BY_ID_LOADING: 'FETCH_MENU_ITEM_BY_ID_LOADING',
  FETCH_MENU_ITEM_BY_ID_REJECT: 'FETCH_MENU_ITEM_BY_ID_REJECT',
  FETCH_MENU_ITEM_BY_ID_FAILED: 'FETCH_MENU_ITEM_BY_ID_FAILED',


  INSERT_NEW_MENU_ITEM_SUCCESS: 'INSERT_NEW_MENU_ITEM_SUCCESS',
  INSERT_NEW_MENU_ITEM_LOADING: 'INSERT_NEW_MENU_ITEM_LOADING',
  INSERT_NEW_MENU_ITEM_REJECT: 'INSERT_NEW_MENU_ITEM_REJECT',
  INSERT_NEW_MENU_ITEM_FAILED: 'INSERT_NEW_MENU_ITEM_FAILED',

  UPDATE_MENU_ITEM_SUCCESS: 'UPDATE_MENU_ITEM_SUCCESS',
  UPDATE_MENU_ITEM_LOADING: 'UPDATE_MENU_ITEM_LOADING',
  UPDATE_MENU_ITEM_REJECT: 'UPDATE_MENU_ITEM_REJECT',
  UPDATE_MENU_ITEM_FAILED: 'UPDATE_MENU_ITEM_FAILED',

  GET_MENU_ITEM_IMAGES_SUCCESS: 'GET_MENU_ITEM_IMAGES_SUCCESS',
  GET_MENU_ITEM_IMAGES_LOADING: 'GET_MENU_ITEM_IMAGES_LOADING',
  GET_MENU_ITEM_IMAGES_REJECT: 'GET_MENU_ITEM_IMAGES_REJECT',
  GET_MENU_ITEM_IMAGES_FAILED: 'GET_MENU_ITEM_IMAGES_FAILED',
};
